<template>
  <div class="cx-test-tab">
    <h3>{{ text }}</h3>
    Content of tab
  </div>
</template>

<script>
export default {
  name: 'CxTestTab',
  props: {
    text: {
      type: String,
      default: 'Default text'
    }
  }
};
</script>

<style lang="less">

.cx-test-tab {
  display: flex;
  flex-direction: column;
  padding: 30px;
}

</style>